import { ADD_ISSUE } from 'actions';
import { IIssue } from 'typings';

export function addIssue(issue: IIssue) {
  return { issue, type: ADD_ISSUE };
}
